'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
const vue_1 = require('vue')
const _hoisted_1 = {
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 24 24'
}
const _hoisted_2 = /*#__PURE__*/ vue_1.createVNode(
  'g',
  {
    fill: 'none'
  },
  [
    /*#__PURE__*/ vue_1.createVNode('path', {
      d: 'M11 5.5a3.5 3.5 0 0 1-3 3.465V11.5h6.25a2.25 2.25 0 0 0 2.25-2.25v-.395A3.502 3.502 0 0 1 17.5 2a3.5 3.5 0 0 1 .5 6.965v.285A3.75 3.75 0 0 1 14.25 13H8v2.035a3.5 3.5 0 1 1-1.5.11v-6.29A3.502 3.502 0 0 1 7.5 2A3.5 3.5 0 0 1 11 5.5zm-3.5 2a2 2 0 1 0 0-4a2 2 0 0 0 0 4zm10 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4zm-8 11a2 2 0 1 0-4 0a2 2 0 0 0 4 0z',
      fill: 'currentColor'
    })
  ],
  -1
  /* HOISTED */
)
exports.default = vue_1.defineComponent({
  name: 'BranchFork24Regular',
  render: function render(_ctx, _cache) {
    return vue_1.openBlock(), vue_1.createBlock('svg', _hoisted_1, [_hoisted_2])
  }
})
